"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPhoneMaskRU = exports.getPhoneMask = exports.getMask = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _ramda = require("ramda");

var _libphonenumberJs = require("libphonenumber-js");

var _mask = require("../constants/mask");

var _masks = require("../constants/masks");

var isEmptyString = function isEmptyString(str) {
  return (0, _ramda.isEmpty)((0, _ramda.trim)(str));
};

var getMask = function getMask(mask) {
  if ((0, _ramda.is)(String, mask) && !isEmptyString(mask)) {
    var result = (0, _toConsumableArray2["default"])(mask).reduce(function (prevValue, item, index, array) {
      var prevItem = index !== 0 && array[index - 1];

      if (item === '\\') {
        return prevValue;
      }

      if (prevItem === '\\') {
        return [].concat((0, _toConsumableArray2["default"])(prevValue), ["".concat(item)]);
      } else {
        var maskItem = _mask.maskItems[item] || item;
        return [].concat((0, _toConsumableArray2["default"])(prevValue), [maskItem]);
      }
    }, []);
    return result;
  } else {
    return mask;
  }
};

exports.getMask = getMask;

var templateToMask = function templateToMask(template) {
  var mask = [];
  var splittedTemplate = (0, _ramda.split)(' ', template);
  var maskParts = splittedTemplate.map(function (item, index) {
    switch (index) {
      case 0:
        return (0, _ramda.replace)(/^./, '+', item);

      case 1:
        return " (".concat(item, ") ");

      case 2:
        return "".concat(item);

      default:
        return "-".concat(item);
    }
  });
  var maskTemplateString = (0, _ramda.join)('', maskParts);
  (0, _toConsumableArray2["default"])(maskTemplateString).forEach(function (element) {
    if (element === 'x') {
      mask.push(/\d/);
    } else {
      mask.push(element);
    }
  });
  return mask;
};

var getPhoneMask = function getPhoneMask(rawValue, _ref) {
  var previousConformedValue = _ref.previousConformedValue;
  var asYouTypeNumber = new _libphonenumberJs.AsYouType();
  asYouTypeNumber.input(rawValue ? "+".concat(rawValue).replace('++', '+') : rawValue);
  var template = asYouTypeNumber.template;

  if (!template && previousConformedValue) {
    asYouTypeNumber.input(previousConformedValue);
    var prevTemplate = asYouTypeNumber.template;

    if (prevTemplate) {
      return templateToMask(prevTemplate);
    }
  }

  if (template) {
    return templateToMask(template);
  } else {
    return _masks.PHONE_MASK;
  }
};

exports.getPhoneMask = getPhoneMask;

var getPhoneMaskRU = function getPhoneMaskRU(value) {
  return value && value[0] === '8' ? _masks.PHONE_MASK_RU_EIGHT : _masks.PHONE_MASK_RU;
};

exports.getPhoneMaskRU = getPhoneMaskRU;